import api, { API } from "./api";

const KEY = "gt_member_token";

export const setMemberToken = (t) => localStorage.setItem(KEY, t);
export const getMemberToken = () => localStorage.getItem(KEY);
export const clearMemberToken = () => localStorage.removeItem(KEY);

export const memberApi = {
  register: (data) => fetch(`${API}/member/register`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data),
  }).then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.detail || "Failed"); return j; }),
  login: (data) => fetch(`${API}/member/login`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data),
  }).then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.detail || "Failed"); return j; }),
};

export async function memberFetch(path, options = {}) {
  const token = getMemberToken();
  const headers = { ...(options.headers || {}), Authorization: token ? `Bearer ${token}` : "" };
  if (options.body && !(options.body instanceof FormData) && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  const r = await fetch(`${API}${path}`, { ...options, headers });
  const j = await r.json().catch(() => ({}));
  if (r.status === 401) {
    clearMemberToken();
    if (window.location.pathname.startsWith("/member") && window.location.pathname !== "/member/login") {
      window.location.href = "/member/login";
    }
  }
  if (!r.ok) throw new Error(j.detail || "Request failed");
  return j;
}
